import { axiosInstance } from "./axiosInstance";
import { NewProduct, IProductInfo } from "@protoplan/types";


export async function getNProducts()
{
  return axiosInstance.post("/products/nProducts")
    .then(resJson => resJson.data)
    .catch(error => console.log("Error retrieving nProducts", error));
}

export async function searchProducts(query?: string, suppId?: number)
{
  return axiosInstance.post("/products/search", { query, suppId })
    .then(resJson => resJson.data as IProductInfo[])
    .catch(error => console.log("Error searching products:", error));
}

export async function getProduct(productId: number)
{
  return axiosInstance.post("/products/product", { productId })
    .then(resJson => resJson.data as IProductInfo)
    .catch(error => console.log("Error getting product with productId " + productId + ":", error));
}

export async function getSimilarProducts(productId: number)
{
  return axiosInstance.post("/products/similarProducts", { "Product-id": productId })
    .then(resJson => resJson.data as IProductInfo[])
    .catch(error => console.log("Error getting similar products:", error));
}

export async function updateForm(productId: number, formId: number)
{
  return axiosInstance.post("/products/updateForm", { "Product-id": productId, "Form-id": formId })
    .then(resJson => resJson.data)
    .catch(error => console.log("Error updating product form:", error));
}

export async function getBrands()
{
  return axiosInstance.post("/products/brands")
    .then(resJson => resJson.data)
    .catch(error => console.log("Error retrieving brands", error));
}

export async function getSupps()
{
  return axiosInstance.post("/products/supps")
    .then(resJson => resJson.data as { suppId: number, name: string }[])
    .catch(error => console.log("Error retrieving supps", error));
}

export interface NewUnitConversion
{
  fromUnitId: number,
  toUnitId: number,
  factor: number
}

export async function postNewProduct(product: NewProduct, unitConversions?: NewUnitConversion[])
{
  return axiosInstance.post("/products/newProduct", { product, unitConversions })
    .then(resJson => resJson.data.product as IProductInfo)
    .catch(error => console.log("Error posting new product or unit conversions", error));
}

export async function deleteProduct(productId: number)
{
  return axiosInstance.post("/products/deleteProduct", { 'Delete-product': productId })
    .catch(error => console.log("Error deleting product", error));
}
